import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Box,
} from "@mui/material";
import React from "react";
import { useStyles } from "../styles";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import useStaff from "../../../../Hooks/staff";
import CustomExpandMore from "../../../../common/CustomExpandMore";
import { useLocation } from "react-router-dom";
import { useRef } from "react";

export const addStaffEmploymentDetailsSchema = Yup.object().shape({
  designation: Yup.string().required("*please enter the Designation"),
  startDate: Yup.string()
    .required("*please select the  From date of Designation")
    .nullable(),
  endDate: Yup.string()
    .required("*please select the  TO date of Designation")
    .nullable(),
  college: Yup.string().required("*Please enter the College Name").nullable(),
  address: Yup.string()
    .required("*Please enter the college Address")
    .nullable(),
});

function AddEmployementInformation(props) {
  const { currentIndex, staffEmploymentRef } = props;

  const classes = useStyles();
  const [edit, setEdit] = React.useState("");
  const location = useLocation();

  React.useEffect(() => {
    if (location.pathname === "/staffManagement/editStaff") {
      setEdit(true);
    } else {
      setEdit(false);
    }
  }, [location]);
  const {
    addStaffEmploymentInfo,
    removeEmploymentAction,
    staffPersonalInfo,
    updateStaffAction,
    addNewEmployment,
    updateEmploymentInfoItemDataAction,
    deleteEmployAction,
  } = useStaff();

  React.useEffect(() => {
    if (staffEmploymentRef.current) {
      const { setFieldValue } = staffEmploymentRef.current;
      setFieldValue(
        "id",
        addNewEmployment && addNewEmployment[currentIndex]?.id
      );
      setFieldValue(
        "idFaculty",
        addNewEmployment &&
          addNewEmployment[currentIndex]?.idFaculty !== undefined
          ? addNewEmployment[currentIndex]?.idFaculty
          : staffPersonalInfo && staffPersonalInfo?.id
      );
    }
  }, [addNewEmployment, staffPersonalInfo]);

  const addStaffEmployment = {
    designation:
      (addNewEmployment && addNewEmployment[currentIndex]?.designation) || "",
    startDate:
      (addNewEmployment && addNewEmployment[currentIndex]?.startDate) || "",
    endDate:
      (addNewEmployment && addNewEmployment[currentIndex]?.endDate) || "",
    college:
      (addNewEmployment && addNewEmployment[currentIndex]?.college) || "",
    address:
      (addNewEmployment && addNewEmployment[currentIndex]?.address) || "",
    id: "",
    idFaculty:
      addNewEmployment &&
      addNewEmployment[currentIndex]?.idFaculty !== undefined
        ? addNewEmployment[currentIndex]?.idFaculty
        : staffPersonalInfo?.id,
  };

  return (
    <Stack sx={{ border: "1px solid #D1D5DB", mb: 2, borderRadius: "23px" }}>
      <Stack sx={{ color: "#25D5A1" }}>
        <Stack
          sx={{
            width: "80px",
            height: "80px",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            borderRadius: "50px",
          }}
          onClick={() => {
            removeEmploymentAction({ key: currentIndex });
            deleteEmployAction({ id: addNewEmployment[currentIndex]?.id });
          }}
        >
          <RemoveIcon />
        </Stack>
      </Stack>
      <Formik
        validationSchema={addStaffEmploymentDetailsSchema}
        initialValues={addStaffEmployment}
        validateOnBlur={false}
        validateOnChange={false}
        enableReinitialize
        innerRef={staffEmploymentRef}
        onSubmit={(values) => {
          // addStaffEmploymentInfo({...values})
        }}
      >
        {(formik) => {
          const {
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            values,
          } = formik;
          return (
            <form id="addStaffEmployment" onSubmit={handleSubmit}>
              <AccordionDetails>
                <Grid container spacing={6}>
                  <Grid item md={4} sm={12}>
                    <Box
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                        mb: 2,
                      }}
                    >
                      <Stack>
                        <TextField
                          id="designation"
                          name="designation"
                          placeholder="Designation"
                          IconComponent={CustomExpandMore}
                          defaultValue=""
                          displayEmpty
                          sx={{
                            width: "200px",
                          }}
                          className={
                            errors.designation && touched.designation
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          onBlur={handleBlur}
                          onChange={(e) => {
                            handleChange(e);
                            updateEmploymentInfoItemDataAction({
                              type: "designation",
                              index: currentIndex,
                              data: e.target.value,
                            });
                          }}
                          value={values.designation}
                        >
                          {/* <MenuItem value="" disabled>
                            Designation
                          </MenuItem>
                          <MenuItem value="Professor">Professor</MenuItem>
                          <MenuItem value="Asst.Professor">
                            Asst.Professor
                          </MenuItem>
                          <MenuItem value="HOD">HOD</MenuItem>
                          <MenuItem value="Lab Technician">
                            Lab Technician
                          </MenuItem> */}
                        </TextField>
                      </Stack>
                      <ErrorMessage
                        name="designation"
                        component="span"
                        className={classes.error}
                      />
                    </Box>
                  </Grid>
                  <Grid item md={4} sm={12}>
                    <Box
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                        mb: 2,
                      }}
                    >
                      <Stack>
                        <TextField
                          id="college"
                          name="college"
                          placeholder="College Name"
                          sx={{
                            width: "200px",
                          }}
                          className={
                            errors.college && touched.college
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          onBlur={handleBlur}
                          onChange={(e) => {
                            handleChange(e);
                            updateEmploymentInfoItemDataAction({
                              type: "college",
                              index: currentIndex,
                              data: e.target.value,
                            });
                          }}
                          value={values.college}
                        />
                      </Stack>
                      <ErrorMessage
                        name="college"
                        component="span"
                        className={classes.error}
                      />
                    </Box>
                    <Stack>
                      <Typography
                        className={classes.label}
                        sx={{
                          mb: 1,
                          mt: 2,
                        }}
                      >
                        FROM
                      </Typography>
                    </Stack>
                    <Stack>
                      <TextField
                        id="startDate"
                        type="date"
                        name="startDate"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        placeholder="Enter start date"
                        sx={{
                          width: "200px",
                        }}
                        className={
                          errors.startDate && touched.startDate
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        onBlur={handleBlur}
                        onChange={(e) => {
                          handleChange(e);
                          updateEmploymentInfoItemDataAction({
                            type: "startDate",
                            index: currentIndex,
                            data: e.target.value,
                          });
                        }}
                        value={values.startDate}
                      />
                      <ErrorMessage
                        name="startDate"
                        component="span"
                        className={classes.error}
                      />
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                        mb: 2,
                      }}
                    ></Stack>
                  </Grid>
                  <Grid item md={4} sm={12}>
                    <Box
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                        mb: 2,
                      }}
                    >
                      <Stack>
                        <TextField
                          id="address"
                          name="address"
                          placeholder="College Address"
                          sx={{
                            width: "200px",
                          }}
                          className={
                            errors.address && touched.address
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          onBlur={handleBlur}
                          onChange={(e) => {
                            handleChange(e);
                            updateEmploymentInfoItemDataAction({
                              type: "address",
                              index: currentIndex,
                              data: e.target.value,
                            });
                          }}
                          value={values.address}
                        />
                      </Stack>
                      <ErrorMessage
                        name="address"
                        component="span"
                        className={classes.error}
                      />
                    </Box>
                    <Stack>
                      <Typography
                        className={classes.label}
                        sx={{
                          mb: 1,
                          mt: 2,
                        }}
                      >
                        TO
                      </Typography>
                    </Stack>
                    <Stack>
                      <TextField
                        id="endDate"
                        type="date"
                        name="endDate"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        placeholder="End date"
                        sx={{
                          width: "200px",
                        }}
                        className={
                          errors.endDate && touched.endDate
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        onBlur={handleBlur}
                        onChange={(e) => {
                          handleChange(e);
                          updateEmploymentInfoItemDataAction({
                            type: "endDate",
                            index: currentIndex,
                            data: e.target.value,
                          });
                        }}
                        value={values.endDate}
                      />
                      <ErrorMessage
                        name="endDate"
                        component="span"
                        className={classes.error}
                      />
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                        mb: 2,
                      }}
                    ></Stack>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </form>
          );
        }}
      </Formik>
    </Stack>
  );
}

export default AddEmployementInformation;
